import { FC, ReactElement } from 'react'

import { ConnectedLoketLeaveBalances } from '@/connectors'

export const LoketLeaveBalancesPage: FC = (): ReactElement => <ConnectedLoketLeaveBalances />
